// import React from "react";
// import "./DigitalPassportParent.css";
// import ComplianceCard from "./ComplianceCard";
// import DigitalPassport from "./DigitalPassport";
// import { Grid } from "@mui/material";

// const DigitalPassportParent = ({ mainData, manufacturerData }) => {
//   const productLink = "https://example.com/product/WH-2024-1547";

//   const handleDownload = () => {
//     const blob = new Blob(["Digital Product Passport Data"], {
//       type: "text/plain",
//     });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.download = "Digital_Product_Passport.txt";
//     link.click();
//     URL.revokeObjectURL(url);
//   };

//   const handleShare = () => {
//     navigator.clipboard.writeText(productLink);
//     alert("Product link copied to clipboard!");
//   };

//   const handleViewOnline = () => {
//     window.open(productLink, "_blank");
//   };

//   return (
//     <div style={{ background: "white" }}>
//       {/* <div className="dpp-container3">
//         <Grid container>
//           <div className="dpp-card left-card">
//           <img
//             src="https://via.placeholder.com/150"
//             alt="QR Code"
//             className="qr-image"
//           />
//           <h3 className="title">Digital Product Passport</h3>
//           <p className="subtitle">
//             Scan to access complete product information, certifications, and
//             lifecycle data
//           </p>
//           <p className="product-id">
//             <a href={productLink} target="_blank" rel="noopener noreferrer">
//               Product ID: WH-2024-1547
//             </a>
//           </p>
//           <p className="status">
//             <span className="status-dot"></span> Verified & Active
//           </p>

//           <div className="buttons">
//             <button className="btn" onClick={handleDownload}>
//               Download
//             </button>
//             <button className="btn" onClick={handleShare}>
//               Share
//             </button>
//             <button className="btn" onClick={handleViewOnline}>
//               View Online
//             </button>
//           </div>

//           <p className="manufacturer">
//             Manufactured by <strong>Global Manufacturing Corp</strong>
//           </p>
//           <p className="date">2024-02-01</p>
//         </div>
//           <Grid item xs={12} lg={6}>
//             <DigitalPassport
//               title="Manufacturer Details"
//               manufacturerData={manufacturerData}
//             />
//           </Grid>
//           <Grid item xs={12} lg={6}>
//             <div style={{ padding: "20px" }}>
//               <ComplianceCard
//                 title="Compliance & Certifications"
//                 certifications="40"
//                 stages="9/12"
//                 tracking="3 processes"
//                 score="100%"
//                 mainData={mainData}
//               />
//             </div>
//           </Grid>
//         </Grid>
//       </div> */}
//       <div
//         className="bottom-tags"
//         style={{ display: "flex", flexDirection: "column" }}
//       >
//         <div>
//           <p style={{ fontSize: "15px" }}>
//             Digital Product Passport certified and verified
//           </p>
//         </div>
//         <div className="tags" style={{ justifyContent: "center" }}>
//           <span className="tag green">ISO 14001</span>
//           <span className="tag blue">Carbon Neutral</span>
//           <span className="tag purple">Circular Economy</span>
//           <span className="tag yellow">ESG Compliant</span>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DigitalPassportParent;


import React from "react"; 
import "./DigitalPassportParent.css"; 
 

const DigitalPassportParent = ({ mainData, manufacturerData }) => {
  const productLink = "https://example.com/product/WH-2024-1547";

  const handleDownload = () => {
    const blob = new Blob(["Digital Product Passport Data"], {
      type: "text/plain",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "Digital_Product_Passport.txt";
    link.click();
    URL.revokeObjectURL(url);
  };

  const handleShare = () => {
    navigator.clipboard.writeText(productLink);
    alert("Product link copied to clipboard!");
  };

  const handleViewOnline = () => {
    window.open(productLink, "_blank");
  };

  return (
    <div style={{ background: "white", padding: "15px", boxSizing: "border-box" }}>
    
      <div
        className="bottom-tags"
        style={{ 
          display: "flex", 
          flexDirection: "column", 
          alignItems: "center",  
          width: "100%",  
          boxSizing: "border-box" 
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "12px", width: "100%" }}>
          <p style={{ fontSize: "14px", margin: 0, color: "#374151", fontWeight: 500 }}>
            Digital Product Passport certified and verified
          </p>
        </div>
        
        <div 
          className="tags" 
          style={{ 
            display: "flex", 
            justifyContent: "center", 
            flexWrap: "wrap", 
            gap: "8px", 
            width: "100%" 
          }}
        > 
          <span className="tag green" style={{ fontSize: "11px", padding: "6px 12px", borderRadius: "20px", border: "1px solid #A7F3D0", backgroundColor: "#ECFDF5", color: "#065F46", whiteSpace: "nowrap" }}>ISO 14001</span>
          <span className="tag blue" style={{ fontSize: "11px", padding: "6px 12px", borderRadius: "20px", border: "1px solid #BFDBFE", backgroundColor: "#EFF6FF", color: "#1E3A8A", whiteSpace: "nowrap" }}>Carbon Neutral</span>
          <span className="tag purple" style={{ fontSize: "11px", padding: "6px 12px", borderRadius: "20px", border: "1px solid #E9D5FF", backgroundColor: "#F5F3FF", color: "#5B21B6", whiteSpace: "nowrap" }}>Circular Economy</span>
          <span className="tag yellow" style={{ fontSize: "11px", padding: "6px 12px", borderRadius: "20px", border: "1px solid #FEF08A", backgroundColor: "#FFFBEB", color: "#92400E", whiteSpace: "nowrap" }}>ESG Compliant</span>
        </div>
      </div>
    </div>
  );
};

export default DigitalPassportParent;